self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        globalAPI: true,
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              if(/^(\/\/)/.test(result)) {
                result = window.location.protocol + result
              }
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "editor.worker.js"
});
require("./standalone/browser/accessibilityHelp/accessibilityHelp.js");
require("./contrib/anchorSelect/browser/anchorSelect.js");
require("./contrib/bracketMatching/browser/bracketMatching.js");
require("./browser/coreCommands.js");
require("./contrib/caretOperations/browser/caretOperations.js");
require("./contrib/caretOperations/browser/transpose.js");
require("./contrib/clipboard/browser/clipboard.js");
require("./contrib/codeAction/browser/codeActionContributions.js");
require("./contrib/codelens/browser/codelensController.js");
require("./contrib/colorPicker/browser/colorContributions.js");
require("./contrib/comment/browser/comment.js");
require("./contrib/contextmenu/browser/contextmenu.js");
require("./contrib/cursorUndo/browser/cursorUndo.js");
require("./contrib/dnd/browser/dnd.js");
require("./contrib/documentSymbols/browser/documentSymbols.js");
require("./contrib/find/browser/findController.js");
require("./contrib/folding/browser/folding.js");
require("./contrib/fontZoom/browser/fontZoom.js");
require("./contrib/format/browser/formatActions.js");
require("./contrib/gotoError/browser/gotoError.js");
require("./standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js");
require("./contrib/gotoSymbol/browser/goToCommands.js");
require("./contrib/gotoSymbol/browser/link/goToDefinitionAtPosition.js");
require("./contrib/hover/browser/hover.js");
require("./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js");
require("./contrib/inPlaceReplace/browser/inPlaceReplace.js");
require("./contrib/indentation/browser/indentation.js");
require("./contrib/inlayHints/browser/inlayHintsContribution.js");
require("./contrib/inlineCompletions/browser/inlineCompletionsContribution.js");
require("./standalone/browser/inspectTokens/inspectTokens.js");
require("./contrib/lineSelection/browser/lineSelection.js");
require("./contrib/linesOperations/browser/linesOperations.js");
require("./contrib/linkedEditing/browser/linkedEditing.js");
require("./contrib/links/browser/links.js");
require("./contrib/multicursor/browser/multicursor.js");
require("./contrib/parameterHints/browser/parameterHints.js");
require("./standalone/browser/quickAccess/standaloneCommandsQuickAccess.js");
require("./standalone/browser/quickAccess/standaloneHelpQuickAccess.js");
require("./standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js");
require("./standalone/browser/referenceSearch/standaloneReferenceSearch.js");
require("./contrib/rename/browser/rename.js");
require("./contrib/smartSelect/browser/smartSelect.js");
require("./contrib/snippet/browser/snippetController2.js");
require("./contrib/suggest/browser/suggestController.js");
require("./standalone/browser/toggleHighContrast/toggleHighContrast.js");
require("./contrib/toggleTabFocusMode/browser/toggleTabFocusMode.js");
require("./contrib/tokenization/browser/tokenization.js");
require("./contrib/unicodeHighlighter/browser/unicodeHighlighter.js");
require("./contrib/unusualLineTerminators/browser/unusualLineTerminators.js");
require("./contrib/viewportSemanticTokens/browser/viewportSemanticTokens.js");
require("./contrib/wordHighlighter/browser/wordHighlighter.js");
require("./contrib/wordOperations/browser/wordOperations.js");
require("./contrib/wordPartOperations/browser/wordPartOperations.js");
module.exports = require("!!./editor.api.js");
require("../basic-languages/twig/twig.contribution.js");